// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"341":"87430e0a","453":"5a4d1be6","804":"34055e53"}[chunkId] + ".chunk.js";
};